import * as React from "react";
export const NavDropDownContainer = (props) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const toggle = () => {
        if (props.toggleIsOpen) {
            props.toggleIsOpen();
        }
        setIsOpen((d) => !d);
    };
    return (React.createElement(React.Fragment, null, React.Children.map(props.children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                // @ts-expect-error
                isOpen: props.isOpen !== undefined ? props.isOpen : isOpen,
                onClick: toggle,
                className: props.className,
            });
        }
        return null;
    })));
};
//# sourceMappingURL=NavDropDownContainer.js.map